<!--
Author: Lsc
Date: 2019-08-20
Desc: 预约赎回
-->
<template>
    <div :class="'bizcomp-order-sell-fund bizcomp ' + className">
        <comp-title :title="title">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/orderselllist' }">
                    预约赎回列表
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title>
        <order-sell-comp ref="orderSellComp" />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import orderSellComp from "@/components/fund/orderSellComp";
export default {
    name: "OrderSellComp",
    components: {
        orderSellComp
    },
    mixins: [mixin],
    data () {
        return {
        };
    },
    mounted () {
    },
    methods: {
    }
};
</script>
